import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const NotApprovedPage = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Implement logout logic here (e.g., clear tokens, redirect)
    navigate('/'); // Redirect to login page after logout
  };

  return (
    <div>
      <h1>Your account is pending approval.</h1>
      <p>Please wait for an administrator to review your account.</p>
      <Button type="primary" onClick={handleLogout}>
        Logout
      </Button>
    </div>
  );
};

export default NotApprovedPage;